import React, {useState} from 'react';
import SideBar from '../SideBar';
import styles from './styles.module.scss';
import rollUpButton from 'common/assets/menu_roll_up-24px.svg';
import openButton from 'common/assets/menu_open-24px.svg';
import hamburger from '../../../common/assets/hamburger-light-gray.svg';

const SideBarContainerView = () => {
  const [displaySideBar, setDisplaySideBar] = useState(false);
  const toggleSideBar = () => {
    setDisplaySideBar(!displaySideBar);
  };

  return (
    <div
      className={displaySideBar ? styles.sideBarContainerShow : styles.sideBarContainerRollUp}
    >
      <img
        className={displaySideBar ? styles.toggleSideBarButtonShow : styles.toggleSideBarButtonRollUp}
        src={displaySideBar ? rollUpButton : openButton}
        alt="closeSideBar"
        onClick={toggleSideBar}
      />
      <img
        className={styles.hamburger}
        src={hamburger}
        alt="hamburger"
        onClick={toggleSideBar}
      />
      <SideBar rollUpSideBar={displaySideBar}/>
      <div
        className={displaySideBar ? styles.overlayOn : styles.overlayOff}
        onClick={toggleSideBar}
      >
      </div>
    </div>
  );
};

export default SideBarContainerView;


